import { Component, signal } from '@angular/core';
import { LayerSpecification } from 'maplibre-gl';
import {
  LayerComponent,
  MapComponent,
  VectorSourceComponent,
} from '@maplibre/ngx-maplibre-gl';
@Component({
  selector: 'app-gis-editor',
  templateUrl: './gis-editor.component.html',
  styleUrls: ['./gis-editor.component.css']
})
export class GisEditorComponent {
  readonly layouts = signal<{ [key: string]: LayerSpecification['layout'] }>({
    countries: {
      visibility: 'none',
    },
    names: {
      visibility: 'none',
      // eslint-disable-next-line @typescript-eslint/naming-convention
      'text-field': '{name:latin}',
      // eslint-disable-next-line @typescript-eslint/naming-convention
      'text-size': 30,
    },
  });

  toggleLayer(evt: any) {
    this.layouts.update((layouts) => ({
      ...layouts,
      [evt.value]: {
        ...layouts[evt.value],
        visibility:
          (layouts[evt.value] as any).visibility === 'visible'
            ? 'none'
            : 'visible',
      },
    }));
  }
}
